DR.codeshare = DR.codeshare || {};
DR.codeshare.struct = DR.codeshare.struct || {};
DR.codeshare.select = DR.codeshare.select || {};
/** @extends {DR._Base} */
DR.codeshare.struct.CheckCodeRe = function(par){
	/** @private */
	this._t = 1393;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.error)) this.error = String(par.error||'');
	if(DR._Base.is(par.eventId)) this.eventId = (parseInt(par.eventId)||0);
};
DR._Base._types[1393] = DR.codeshare.struct.CheckCodeRe;
DR.codeshare.struct.CheckCodeRe[__P] = new DR._Base;
DR.codeshare.struct.CheckCodeRe[__P][__C] = DR.codeshare.struct.CheckCodeRe;
/** @type {String} */
DR.codeshare.struct.CheckCodeRe.prototype.error = null;
/** @type {Number|null} */
DR.codeshare.struct.CheckCodeRe.prototype.eventId = null;

/** @extends {DR._Base} */
DR.codeshare.struct.ClaimCodeRe = function(par){
	/** @private */
	this._t = 1390;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.count)) this.count = (parseInt(par.count)||0);
	if(DR._Base.is(par.error)) this.error = String(par.error||'');
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.teams)) this.teams = (parseInt(par.teams)||0);
};
DR._Base._types[1390] = DR.codeshare.struct.ClaimCodeRe;
DR.codeshare.struct.ClaimCodeRe[__P] = new DR._Base;
DR.codeshare.struct.ClaimCodeRe[__P][__C] = DR.codeshare.struct.ClaimCodeRe;
/** @type {Number|null} */
DR.codeshare.struct.ClaimCodeRe.prototype.count = null;
/** @type {String|null} */
DR.codeshare.struct.ClaimCodeRe.prototype.error = null;
/** @type {Number|null} */
DR.codeshare.struct.ClaimCodeRe.prototype.points = null;
/** @type {Number|null} */
DR.codeshare.struct.ClaimCodeRe.prototype.teams = null;

/** @extends {DR._Method} */
DR.codeshare.CheckCode = function(par){
	this.select = [];
	/** @private */
	this._t = 1391;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1391] = DR.codeshare.CheckCode;
DR.codeshare.CheckCode[__CL] = "CodeShare__CheckCode";
DR.codeshare.CheckCode[__P] = new DR._Method;
DR.codeshare.CheckCode[__P][__C] = DR.codeshare.CheckCode;
/** @type {String} */
DR.codeshare.CheckCode.prototype.code = null;
/** @type {DR.codeshare.struct.CheckCodeRe} */
DR.codeshare.CheckCode.prototype.re = null;

/** @extends {DR._Method} */
DR.codeshare.ClaimCode = function(par){
	this.select = [];
	/** @private */
	this._t = 1392;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1392] = DR.codeshare.ClaimCode;
DR.codeshare.ClaimCode[__CL] = "CodeShare__ClaimCode";
DR.codeshare.ClaimCode[__P] = new DR._Method;
DR.codeshare.ClaimCode[__P][__C] = DR.codeshare.ClaimCode;
/** @type {String} */
DR.codeshare.ClaimCode.prototype.code = null;
/** @type {DR.codeshare.struct.ClaimCodeRe} */
DR.codeshare.ClaimCode.prototype.re = null;

/** @extends {DR._Method} */
DR.codeshare.ClaimCodeWithTeamCode = function(par){
	this.select = [];
	/** @private */
	this._t = 1394;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1394] = DR.codeshare.ClaimCodeWithTeamCode;
DR.codeshare.ClaimCodeWithTeamCode[__CL] = "CodeShare__ClaimCodeWithTeamCode";
DR.codeshare.ClaimCodeWithTeamCode[__P] = new DR._Method;
DR.codeshare.ClaimCodeWithTeamCode[__P][__C] = DR.codeshare.ClaimCodeWithTeamCode;
/** @type {String} */
DR.codeshare.ClaimCodeWithTeamCode.prototype.code = null;
/** @type {String} */
DR.codeshare.ClaimCodeWithTeamCode.prototype.team = null;
/** @type {DR.codeshare.struct.ClaimCodeRe} */
DR.codeshare.ClaimCodeWithTeamCode.prototype.re = null;

D.loaded();